import React from 'react';
import PropTypes from 'prop-types';

import { BadgesView } from '../../badges/component/view';

import './view.scss';

export const ControlsView = ({
    headline,
    filters,
    areBadgesVisible,
    setFilter,
    clearFilters,
    toggleFiltersVisibility,
    isMainFilterBadgeShown,
    isAccesories
}) => (
    <div className="controls">
        <div className="controls__buttons">
            <button
                className="controls__filter"
                type="button"
                onClick={ () => {
                    toggleFiltersVisibility();
                } }
            >
                Filtruj
            </button>
            {
                (areBadgesVisible)
                    && (
                        <button
                            className="controls__clear"
                            type="button"
                            onClick={ () => {
                                clearFilters();
                            } }
                        >
                            Wyczyść filtry
                        </button>
                    )
            }
        </div>
        <div className="controls__container">
            {
                headline
                && <h1 className="controls__headline">{ headline }</h1>
            }
            {
                // this lines determines if the badges are shown
                // Badges are now shown if it is the first main fillter is being setted, so it does not appear for a moment on the screen.
                // Standard line would be just (areBadgesVisible)
                (areBadgesVisible && (isMainFilterBadgeShown || isAccesories))
                    && (<BadgesView filters={ filters } setFilter={ setFilter } />)
            }
        </div>
    </div>
);

ControlsView.propTypes = {
    headline: PropTypes.string.isRequired,
    filters: PropTypes.instanceOf(Object).isRequired,
    areBadgesVisible: PropTypes.bool.isRequired,
    setFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    toggleFiltersVisibility: PropTypes.func.isRequired,
    isMainFilterBadgeShown: PropTypes.bool.isRequired,
    isAccesories: PropTypes.bool.isRequired
};